var map = {
	"./critical_hut.png": "a4b8",
	"./critical_hut.svg": "2520",
	"./ct-bgg.png": "e5a2",
	"./ct-facebook.png": "a8ff",
	"./manufacturer_god.png": "20de",
	"./manufacturer_god.svg": "1670",
	"./translator_hubertrinner.png": "6d27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9491";